import React from 'react'
import { Field } from 'formik'
import { formInputStyle, InputForm } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { SmallText } from 'app/common/typography'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import styled from 'styled-components'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { colors as colors2 } from 'app-v2/design-systems/theme/colors'
const { chalk, grey, red5, text } = colors
const { flameSansRegular } = fonts

type Props = {
    name: string,
    labelKey?: string,
    type: string,
    labelColor?: string,
    placeholderKey?: string,
    className?: string,
    spellCheck?: boolean,
    maxLength?: number,
    disabled?: boolean,
    handleClick?: Function,
    TextStyle?: any,
    intl: IntlShape,
    isPastable?: boolean
}

const Input = injectIntl((props: Props) => {
    const {
        name,
        labelKey,
        type,
        placeholderKey,
        className,
        spellCheck = false,
        intl,
        maxLength,
        labelColor = grey,
        disabled = false,
        handleClick,
        TextStyle = SmallText,
        isPastable = true
    } = props
    const onPaste = isPastable ? undefined : e => e.preventDefault()

    return (
        <InputForm className={className} onClick={handleClick && handleClick}>
            {labelKey && (
                <FormattedMessage id={labelKey}>
                    {(text: string) => (
                        <TextStyle color={labelColor}>{text}</TextStyle>
                    )}
                </FormattedMessage>
            )}
            <StyledField
                name={name}
                disabled={disabled}
                maxLength={maxLength}
                type={type}
                placeholder={
                    placeholderKey
                        ? intl.formatMessage({ id: placeholderKey })
                        : ''
                }
                className={className}
                spellCheck={spellCheck}
                onPaste={onPaste}
            />
        </InputForm>
    )
})

const StyledField = styled(Field)`
    border-radius: 10px !important;
    background-color: white;
    &:disabled {
        background-color: ${chalk};
    }
    &.restaurant {
        ${formInputStyle};
        color: ${text};
        background-color: ${red5};
        border: none;
        border-radius: 20px;
        font-style: italic;
        font-size: 14px;
        line-height: 16px;
        padding-left: 16px;
        padding-right: 56px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        background-color: ${chalk};
        &.birthdayRestaurant {
            cursor: pointer;
            background-color: white;
            opacity: 1;
        }
        &::placeholder {
            font-family: ${flameSansRegular};
        }
    }

    &.tpkModal {
        &::placeholder {
            color: ${colors.grey30};
        }
        padding: 12px 14px;
        font-size: 16px;
        line-height: 1.5;
        border: 1px solid ${colors2.bbq30};
        color: ${colors2.bbqBrown};
        height: auto;
    }
`

export { Input }
